import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { BlazeCheckboxChange } from '@blaze-shared/shared-ui';
import { isNullish } from '@blaze-shared/shared-util';

import { type InlineEditorConfig } from '../base-editor/inline-editor.types';

@UntilDestroy()
@Component({
  selector: 'be-boolean-editor',
  templateUrl: './boolean-editor.component.html',
  styleUrls: ['./boolean-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableBooleanEditorComponent {
  valueChange = output<string | null>();

  @Input() config?: InlineEditorConfig;

  formControl = new UntypedFormControl(null);

  @Input() set value(val: number | string | boolean | undefined) {
    if (isNullish(val) || typeof val === 'string') {
      return;
    }
    this.formControl.patchValue(val);
  }

  constructor() {
    this.formControl.valueChanges.pipe(untilDestroyed(this)).subscribe((value) => {
      this.emitValue(value);
    });
  }

  changeValue(event: BlazeCheckboxChange): void {
    this.formControl.patchValue(event.checked);
  }

  private emitValue(value: string): void {
    this.valueChange.emit(value === '' ? null : value);
  }
}
